<template>
    <div class="shopPageWrapper">
        <banner :shopData="shopData" @openContactPopup="$emit('openContactPopup')"/>
        <div class="mainContent">
            <div class="singleSection" id="singleSectionBig" style="background-color: white;">
                <img 
                    class="backgroundImgOne"
                    :src="require('./../assets/shopLanding/backgroundImage.png')" 
                    alt=""
                >
                <div class="sectionBody">
                    <textSection @openContactPopup="$emit('openContactPopup')" />
                </div>
            </div>
            <!-- <div class="singleSection" id="singleSectionSmall" style="background-color: white;">
                <div class="sectionBody">
                    <partnerLogos />
                </div>
            </div> -->
            <!-- <div class="singleSection" id="singleSectionBigRefs" style="background-color: #F4F7F9; position: relative;">
                <img 
                    class="backgroundImgThree"
                    :src="require('./../assets/shopLanding/sections/background1.png')" 
                    alt=""
                >
                <div class="sectionBody">
                    <textSectionAlt @openContactPopup="$emit('openContactPopup')" />
                </div>
            </div> -->
            <!-- <div class="singleSection" id="singleSectionRefs" style="background-color: #F4F7F9;">
                <img 
                    class="backgroundImgTwo"
                    :src="require('./../assets/shopLanding/backgroundImage.png')" 
                    alt=""
                >
                <div class="sectionBody">
                     <h1 style="margin: 0px; margin-bottom: 85px;">Märkimisväärsed projektid</h1> -->
                    <!-- <references />
                </div>
            </div> --> 
            <!-- <div class="singleSection" id="singleSectionBigFeedback" style="background-color: #fff; position: relative;">
                <img 
                    class="backgroundImgLeft"
                    :src="require('./../assets/shopLanding/backgroundImage.png')" 
                    alt=""
                >
                <div class="sectionBody">
                    <testimonials @openContactPopup="$emit('openContactPopup')" />
                </div>
            </div> -->
            <div class="singleSection" style="padding: 0">
                <img 
                    class="sectionBackground"
                    :src="require('./../assets/shopLanding/sections/image1.png')" 
                    alt=""
                >
                <div class="sectionBody">
                    <ourServices @openContactPopup="$emit('openContactPopup')" />
                </div>
            </div>
            <!-- <div class="singleSection" id="singleSectionCatalog" style="background-color: white;">
                <img 
                    class="backgroundImgTwo"
                    :src="require('./../assets/shopLanding/backgroundImage.png')" 
                    alt=""
                >
                <div class="sectionBody">
                    <h1 style="margin: 0px; margin-bottom: 2px;">{{ $t('catalog.title', currentLang) }}</h1>
                    <p style="margin: 0; margin-bottom: 14px; border-bottom: 1px solid rgb(230,230,230); padding-bottom: 20px;color: #3a5a75; font-size: 18px" >{{ $t('catalog.text', currentLang) }}</p>
                    <Button 
                        :label="$t('buttons.shippingOptions', currentLang)" 
                        style="padding-left: 0; color: steelblue" 
                        @click="$emit('showShippingProfileDrawer')" 
                        icon="pi pi-send"  
                        outlined 
                        text  
                    />
                    <Button 
                        :label="$t('buttons.shopCatalog', currentLang)" 
                        style="margin-left: 10px; margin-right: 10px; border: 1px solid steelblue; color: steelblue" 
                        @click="$router.push({ name: 'catalogPage' })" 
                        icon="pi pi-shopping-cart"   
                        severity="contrast"  
                        outlined  
                    />
                    <Button 
                        :label="$t('buttons.categories', currentLang)" 
                        style="margin-left: auto; color: steelblue" 
                        @click="$emit('openCategoriesDrawer')" 
                        icon="pi pi-list"  
                        outlined text  
                    />
                    <div class="products" v-if="isVisible">
                        <productCard 
                            class="productCardComponent"
                            v-for="(element, index) in listingData.slice(0, 10)" :key="index"
                            @openCartSidebar="$emit('openCartSidebar')"
                            @logout="$emit('logout')"
                            :listingData="element"
                            :index="5 + index"
                            :waitTime="cardLoadingTime"
                            :currentLang="currentLang"
                        />
                    </div>
                    <Button 
                        style="position: absolute; right: 0;bottom: -55px; color: steelblue" 
                        :label="$t('buttons.moreProducts', currentLang)" 
                        @click="$router.push({ name: 'catalogPage' })" 
                        icon="pi pi-external-link"  
                        outlined 
                        text 
                        severity="info"  
                    />
                </div>
            </div> -->
            <div class="singleSection" id="singleSectionBigContact" style="background-color: #F4F7F9;">
                <img 
                    class="backgroundImgTwo"
                    :src="require('./../assets/shopLanding/backgroundImage.png')" 
                    alt=""
                >
                <div class="sectionBody">
                    <contactSection @openContactPopup="$emit('openContactPopup')" />
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import banner from '../components/shopLanding/banner.vue'
import textSection from '../components/shopLanding/textSection.vue'
// import partnerLogos from '../components/shopLanding/partnerLogos.vue'
// import references from '../components/shopLanding/references.vue'
import ourServices from '../components/shopLanding/ourServices.vue'
// import productCard from '../components/shopLanding/productCard-small.vue'
import contactSection from '../components/shopLanding/contactSection.vue'
// import Button from 'primevue/button'
// import textSectionAlt from '@/components/shopLanding/textSectionAlt.vue'
// import testimonials from '@/components/shopLanding/testimonials.vue'
// import Carousel from 'primevue/carousel';

export default {
    name: 'shopLanding',
    components: {
        banner,
        textSection,
        // partnerLogos,
        // references,
        ourServices,
        // productCard,
        contactSection,
        // textSectionAlt,
        // testimonials,
        // Button,
        // Carousel
    },
    computed: {
        currentLang() {
            return this.$route.params.lang || 'et';
        },
    },
    watch: {
        listingData() {
            this.isVisible = false
            this.isVisible = true
        }
    }, 
    props: {
        idShop: {},

        shopData: {},
        shopPageUrl: {},

        feedbacksData: {},
        feedbackStatsData: {},

        listingData: {},
        listingsDataRaw: {},
        cardLoadingTime: {},
        counter: {},

        shippingProfileData: {},
    },
    data() {
        return {
            isVisible: true,
            activeTab: 0,
        };
    },
    methods: {
        setActiveTab(index) {
            this.activeTab = index
            this.$emit('getShopListings')
        }
    },
    created() {
      // Lifecycle hook - called after the instance is created

    },
    mounted() {
      // Lifecycle hook - called after the component is mounted to the DOM
    
    },
    updated() {
      // Lifecycle hook - called after a data change causes the DOM to re-render
    
    },
  };
</script>
  
<style scoped>
.shopPageWrapper {
    position: relative;
    width: 100%;
    padding-bottom: 0px;
}
.mainContent {
    /* width: 1300px; */
    margin: 0 auto;
}
.singleSection {
    position: relative;
    padding-top: 50px;
    padding-bottom: 50px;
}
#singleSectionBig {
    padding-top: 85px;
    padding-bottom: 100px;
}
#singleSectionBigRefs {
    padding-top: 150px;
}
#singleSectionRefs {
    padding-top: 90px;
    padding-bottom: 110px;
}
#singleSectionBigFeedback {
    padding-top: 180px;
    padding-bottom: 180px;
}
#singleSectionSmall {
    padding-top: 20px;
    padding-bottom: 85px;
}
#singleSectionCatalog {
    margin-top: 125px;
}
#singleSectionBigContact {
    padding-top: 85px;
    padding-bottom: 100px;
}
.sectionBody {
    position: relative;
    width: 1300px;
    margin: 0 auto;
}
.sectionBackground {
    position: absolute;
    opacity: 0.5;
}
.productCardGrid {
    margin-top: 20px;
    margin-bottom: 50px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    row-gap: 30px;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
}
 h3 {
    font-family: 'Satoshi-Bold';
    font-size: 22px;
    color: #22262A;
    margin-top: 35px;
}
.tags {
    margin-top: 30px;
    margin-left: 25px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-column-gap: 7px;
       -moz-column-gap: 7px;
            column-gap: 7px;
}
.singleTag {
    border: 1px solid #e7e9eb;
    border-radius: 20px;
    height: -webkit-fit-content;
    height: -moz-fit-content;
    height: fit-content;
    padding: 10px 20px 10px 20px;
    font-family: 'Satoshi-Bold';
    font-size: 14px;
    color: #57636C;
    background: white;
    cursor: pointer;
}
.active-tag {
    background-color: orange;
    color: white;
    border: 1px solid transparent;
}
.arrowIcon {
    position: relative;
    background: #e8f9e9;
    height: 40px;
    width: 40px;
}
.arrowIcon i {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    font-size: 30px;
    height: -webkit-fit-content;
    height: -moz-fit-content;
    height: fit-content;
}
.products {
    margin-top: 35px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    padding-left: 0px;
    row-gap: 30px;
    -webkit-column-gap: 25px;
       -moz-column-gap: 25px;
            column-gap: 25px;
    margin-bottom: 50px;
}
.backgroundImgOne {
    position: absolute;
    right: 0px;
    bottom: -30px;
    z-index: 0;
    width: 600px;
    opacity: .18;
}
.backgroundImgLeft {
    position: absolute;
    left: 0;
    bottom: 0;
    top: -40px;
    margin: auto;
    z-index: 0;
    width: 600px;
    opacity: .18;
    -webkit-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    transform: rotate(180deg);
}
.backgroundImgTwo {
    position: absolute;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto;
    z-index: 0;
    width: 700px;
    opacity: .18;
}
.backgroundImgThree {
    position: absolute;
    top: 0;
    bottom: -0px;
    right: 350px;
    margin:  auto;
    z-index: 0;
    width: 50%;
    opacity: .8;
}
@media(max-width: 1340px) {
    .sectionBody {
        width: 100%;
        padding-left: 20px;
        padding-right: 20px;
    }
}
@media (max-width: 500px) {
    .sectionBody h1 {
        font-size: 8vw;
    }
    #singleSectionBig {
        padding-top: 40px;
    }
    #singleSectionSmall {
        padding-top: 0px;
        padding-bottom: 30px;
    }
    #singleSectionBigRefs {
        padding-top: 40px;
    }
    #singleSectionRefs {
        padding-bottom: 40px;
    }
    #singleSectionBigFeedback {
        padding-top: 40px;
        padding-bottom: 40px;
    }
    #singleSectionCatalog {
        margin-top:75px;
    }
    #singleSectionBigContact {
        padding-top: 10px;
        padding-bottom: 50px;
    }
}
</style>